import React from 'react';
import { Box } from '@mui/material';

const StatusRenderer = (props) => {
  const status = props.value;

  let backgroundColor = '#e0e0e0';
  let color = '#000';
  switch (status) {
    case 'Pending Approval':
      backgroundColor = '#fff3cd';
      color = '#856404';
      break;
    case 'Approved':
      backgroundColor = '#dbeafe';
      color = '#1e4ed8';
      break;
    case 'Send':
      backgroundColor = '#f3e9ff';
      color = '#7e22cf';
      break;
    case 'Paid':
      backgroundColor = '#17a34a';
      color = '#fff';
      break;
    case 'Rejected':
      backgroundColor = '#f8d7da';
      color = '#721c24';
      break;
    default:
      break;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Box
        style={{
          backgroundColor: backgroundColor,
          color: color,
          borderRadius: '4px',
          padding: '4px 12px',
          fontSize: '12px',
          fontWeight: '600',
          textTransform: 'uppercase',
          lineHeight: 'normal',
          textAlign: 'center',
          minWidth: '100px'
        }}
      >
        {status}
      </Box>
    </Box>
  );
};

export default StatusRenderer;